import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';

const SocialLink = ({ link, children, encodedUrl }) => {
  return (
    <Link href={`${link}${encodedUrl}`}>
      <a target="_blank">
        {children}
      </a>
    </Link>
  );
};

export default SocialLink;

SocialLink.propTypes = {
  link: PropTypes.string,
  children: PropTypes.node,
  encodedUrl: PropTypes.string
};
